/**
 * DateRangeFilter Component
 *
 * Two date inputs for filtering care logs by date range.
 */

import { Calendar, X } from 'lucide-react';

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onClear?: () => void;
}

function getTodayDateString(): string {
  const now = new Date();
  return now.toISOString().split('T')[0];
}

export function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
}: DateRangeFilterProps): JSX.Element {
  const hasFilters = startDate || endDate;

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label htmlFor="startDate" className="label text-xs flex items-center gap-1">
          <Calendar size={12} />
          From
        </label>
        <input
          id="startDate"
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          max={endDate || getTodayDateString()}
          className="input input-sm w-auto"
        />
      </div>

      <div>
        <label htmlFor="endDate" className="label text-xs flex items-center gap-1">
          <Calendar size={12} />
          To
        </label>
        <input
          id="endDate"
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          min={startDate}
          max={getTodayDateString()}
          className="input input-sm w-auto"
        />
      </div>

      {hasFilters && onClear && (
        <button
          onClick={onClear}
          className="btn-ghost btn-sm flex items-center gap-1 text-muted hover:text-ink"
          title="Clear date filters"
        >
          <X size={14} />
          Clear
        </button>
      )}
    </div>
  );
}

export default DateRangeFilter;
